/*
 * Partner attribution for the commission agreements (Hörmann, WAREMA).
 *
 * The homee apps open the shop with ?b2b_partner=<partner>. The value comes from the
 * cube setting of the same name, which the core derives from the first radio cube that
 * was put on the Brain Cube. We keep it in the browser and copy it into the cart
 * attributes, so it ends up on the order (Admin: "Additional details",
 * API: order.note_attributes / customAttributes). The customer never sees it.
 */
(function () {
  var KEY = 'homee_b2b_partner';
  var ATTRIBUTE = 'b2b_partner';
  var MAX_AGE_DAYS = 30;
  var PARTNERS = ['afriso', 'estmk', 'hoermann', 'homee', 'pum', 'varia3', 'warema'];

  function readStored() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(KEY));
      if (!stored || PARTNERS.indexOf(stored.partner) === -1) return null;
      if (Date.now() - stored.savedAt > MAX_AGE_DAYS * 24 * 60 * 60 * 1000) {
        window.localStorage.removeItem(KEY);
        return null;
      }
      return stored.partner;
    } catch (e) {
      return null;
    }
  }

  function store(partner) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ partner: partner, savedAt: Date.now() }));
    } catch (e) {
      // Storage can be blocked; the cart attribute below still covers this visit.
    }
  }

  function fromUrl() {
    var match = /[?&]b2b_partner=([^&#]*)/.exec(window.location.search);
    if (!match) return null;
    var partner = decodeURIComponent(match[1]).toLowerCase();
    return PARTNERS.indexOf(partner) === -1 ? null : partner;
  }

  var partner = fromUrl();
  if (partner) {
    store(partner);
  } else {
    partner = readStored();
  }
  if (!partner || !window.fetch) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // A new cart is created after every order, so the attribute has to be checked on each page.
  fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (cart.attributes && cart.attributes[ATTRIBUTE] === partner) return;
      var attributes = {};
      attributes[ATTRIBUTE] = partner;
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
      });
    })
    .catch(function () {
      // Attribution must never get in the way of shopping.
    });
})();
